module.exports = __webpack_public_path__ + "static/media/030_IMG_2777.e084baae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/030_IMG_2777.png
// module id = 409
// module chunks = 0